import React, {useEffect, useState} from 'react'
import Navigation from 'components/complex/navigation/Navigation';
import AppBar from 'components/complex/appbar/AppBar';
import IEInfo from 'components/popup/IEinfo';
import Browser from 'libs/Browser';
import PurchaserRouter from "./PurchaserRouter";
import SalesNotificationPopup from "components/popup/salesNotification/SalesNotificationPopup";
import UploadService from "services/UploadService";
import ConfirmCloseStepper from "components/popup/confirmCloseStepper/ConfirmCloseStepper";
import Feedback from "components/complex/feedback/Feedback";
import EzamowieniaOauth from "../../components/complex/ezamowienia/EzamowieniaOauth";


function PurchaserRoot() {
    const [ieOpen, setIeOpen] = useState(Browser.isIE)

    useEffect(() => {
        UploadService.getValidExtensions();
        return () => UploadService.clearValidExtensionsResource();
    }, [])

    return (
        <>
            <Navigation purchaser/>
            <AppBar id="toolBar"/>
            <PurchaserRouter/>
            <IEInfo
                open={ieOpen}
                onClose={() => setIeOpen(false)}
            />
            <Feedback pollType="ezam-nps"/>
            <SalesNotificationPopup />
            <ConfirmCloseStepper />
            <EzamowieniaOauth />
        </>
    )
}

export default PurchaserRoot;
